import BatchPaymentsActionTypes from './batchPayments-types'

const INITIAL_STATE = {
    loader: null,
    success: null,
    error: null,
    batchPayment: null,
    batchPayments: null,
    batchPaymentRequests: null,
    batchPaymentStatuses: null,
}

const batchPaymentsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        /*************** Import Batch Payment File ********************/
        case BatchPaymentsActionTypes.START_IMPORT_BATCH_PAYMENT_FILE:
            return {
                ...state,
                loader: { ...state.loader, IMPORT_BATCH_PAYMENT_FILE: true },
            }
        case BatchPaymentsActionTypes.SUCCESS_IMPORT_BATCH_PAYMENT_FILE:
            return {
                ...state,
                error: { ...state.error, IMPORT_BATCH_PAYMENT_FILE: null },
                loader: { ...state.loader, IMPORT_BATCH_PAYMENT_FILE: null },
                success: { ...state.success, IMPORT_BATCH_PAYMENT_FILE: true },
            }
        case BatchPaymentsActionTypes.FAILURE_IMPORT_BATCH_PAYMENT_FILE:
            return {
                ...state,
                error: { ...state.error, IMPORT_BATCH_PAYMENT_FILE: true },
                loader: { ...state.loader, IMPORT_BATCH_PAYMENT_FILE: null },
                success: { ...state.success, IMPORT_BATCH_PAYMENT_FILE: null },
            }
        case BatchPaymentsActionTypes.FINISH_IMPORT_BATCH_PAYMENT_FILE:
            return {
                ...state,
                error: { ...state.error, IMPORT_BATCH_PAYMENT_FILE: null },
                loader: { ...state.loader, IMPORT_BATCH_PAYMENT_FILE: null },
                success: { ...state.success, IMPORT_BATCH_PAYMENT_FILE: null },
            }

        /*************** Execute Batch Payment Requests ********************/
        case BatchPaymentsActionTypes.START_EXECUTE_BATCH_PAYMENT_REQUESTS:
            return {
                ...state,
                loader: { ...state.loader, EXECUTE_BATCH_PAYMENT_REQUESTS: true },
            }
        case BatchPaymentsActionTypes.SUCCESS_EXECUTE_BATCH_PAYMENT_REQUESTS:
            return {
                ...state,
                error: { ...state.error, EXECUTE_BATCH_PAYMENT_REQUESTS: null },
                loader: { ...state.loader, EXECUTE_BATCH_PAYMENT_REQUESTS: null },
                success: { ...state.success, EXECUTE_BATCH_PAYMENT_REQUESTS: true },
            }
        case BatchPaymentsActionTypes.FAILURE_EXECUTE_BATCH_PAYMENT_REQUESTS:
            return {
                ...state,
                error: { ...state.error, EXECUTE_BATCH_PAYMENT_REQUESTS: true },
                loader: { ...state.loader, EXECUTE_BATCH_PAYMENT_REQUESTS: null },
                success: { ...state.success, EXECUTE_BATCH_PAYMENT_REQUESTS: null },
            }
        case BatchPaymentsActionTypes.FINISH_EXECUTE_BATCH_PAYMENT_REQUESTS:
            return {
                ...state,
                error: { ...state.error, EXECUTE_BATCH_PAYMENT_REQUESTS: null },
                loader: { ...state.loader, EXECUTE_BATCH_PAYMENT_REQUESTS: null },
                success: { ...state.success, EXECUTE_BATCH_PAYMENT_REQUESTS: null },
            }

        /*************** Cancel Batch Payment Requests ********************/
        case BatchPaymentsActionTypes.START_CANCEL_BATCH_PAYMENT_REQUESTS:
            return {
                ...state,
                loader: { ...state.loader, CANCEL_BATCH_PAYMENT_REQUESTS: true },
            }
        case BatchPaymentsActionTypes.SUCCESS_CANCEL_BATCH_PAYMENT_REQUESTS:
            return {
                ...state,
                error: { ...state.error, CANCEL_BATCH_PAYMENT_REQUESTS: null },
                loader: { ...state.loader, CANCEL_BATCH_PAYMENT_REQUESTS: null },
                success: { ...state.success, CANCEL_BATCH_PAYMENT_REQUESTS: true },
            }
        case BatchPaymentsActionTypes.FAILURE_CANCEL_BATCH_PAYMENT_REQUESTS:
            return {
                ...state,
                error: { ...state.error, CANCEL_BATCH_PAYMENT_REQUESTS: true },
                loader: { ...state.loader, CANCEL_BATCH_PAYMENT_REQUESTS: null },
                success: { ...state.success, CANCEL_BATCH_PAYMENT_REQUESTS: null },
            }
        case BatchPaymentsActionTypes.FINISH_CANCEL_BATCH_PAYMENT_REQUESTS:
            return {
                ...state,
                error: { ...state.error, CANCEL_BATCH_PAYMENT_REQUESTS: null },
                loader: { ...state.loader, CANCEL_BATCH_PAYMENT_REQUESTS: null },
                success: { ...state.success, CANCEL_BATCH_PAYMENT_REQUESTS: null },
            }

        /*************** Get Batch Payment Statuses ********************/
        case BatchPaymentsActionTypes.START_GET_BATCH_PAYMENT_STATUSES:
            return {
                ...state,
                loader: { ...state.loader, GET_BATCH_PAYMENT_STATUSES: true },
            }
        case BatchPaymentsActionTypes.SUCCESS_GET_BATCH_PAYMENT_STATUSES:
            return {
                ...state,
                batchPaymentStatuses: action.payload,
                error: { ...state.error, GET_BATCH_PAYMENT_STATUSES: null },
                loader: { ...state.loader, GET_BATCH_PAYMENT_STATUSES: null },
                success: { ...state.success, GET_BATCH_PAYMENT_STATUSES: true },
            }
        case BatchPaymentsActionTypes.FAILURE_GET_BATCH_PAYMENT_STATUSES:
            return {
                ...state,
                batchPaymentStatuses: null,
                error: { ...state.error, GET_BATCH_PAYMENT_STATUSES: true },
                loader: { ...state.loader, GET_BATCH_PAYMENT_STATUSES: null },
                success: { ...state.success, GET_BATCH_PAYMENT_STATUSES: null },
            }
        case BatchPaymentsActionTypes.FINISH_GET_BATCH_PAYMENT_STATUSES:
            return {
                ...state,
                batchPaymentStatuses: null,
                error: { ...state.error, GET_BATCH_PAYMENT_STATUSES: null },
                loader: { ...state.loader, GET_BATCH_PAYMENT_STATUSES: null },
                success: { ...state.success, GET_BATCH_PAYMENT_STATUSES: null },
            }

        /*******************  Fetch All Imported Batch Payments ********************* */
        case BatchPaymentsActionTypes.START_GET_IMPORTED_BATCH_PAYMENTS:
            return {
                ...state,
                loader: { ...state.loader, GET_IMPORTED_BATCH_PAYMENTS: true },
            }
        case BatchPaymentsActionTypes.SUCCESS_GET_IMPORTED_BATCH_PAYMENTS:
            return {
                ...state,
                batchPayments: action.payload,
                error: { ...state.error, GET_IMPORTED_BATCH_PAYMENTS: null },
                loader: { ...state.loader, GET_IMPORTED_BATCH_PAYMENTS: null },
                success: { ...state.success, GET_IMPORTED_BATCH_PAYMENTS: true },
            }
        case BatchPaymentsActionTypes.FAILURE_GET_IMPORTED_BATCH_PAYMENTS:
            return {
                ...state,
                batchPayments: null,
                error: { ...state.error, GET_IMPORTED_BATCH_PAYMENTS: true },
                loader: { ...state.loader, GET_IMPORTED_BATCH_PAYMENTS: null },
                success: { ...state.success, GET_IMPORTED_BATCH_PAYMENTS: null },
            }
        case BatchPaymentsActionTypes.FINISH_GET_IMPORTED_BATCH_PAYMENTS:
            return {
                ...state,
                batchPayments: null,
                error: { ...state.error, GET_IMPORTED_BATCH_PAYMENTS: null },
                loader: { ...state.loader, GET_IMPORTED_BATCH_PAYMENTS: null },
                success: { ...state.success, GET_IMPORTED_BATCH_PAYMENTS: null },
            }

        /*******************  Fetch Single Imported Batch Payment ********************* */
        case BatchPaymentsActionTypes.START_GET_SINGLE_IMPORTED_BATCH_PAYMENT:
            return {
                ...state,
                loader: { ...state.loader, GET_SINGLE_IMPORTED_BATCH_PAYMENT: true },
            }
        case BatchPaymentsActionTypes.SUCCESS_GET_SINGLE_IMPORTED_BATCH_PAYMENT:
            return {
                ...state,
                batchPayment: action.payload,
                error: { ...state.error, GET_SINGLE_IMPORTED_BATCH_PAYMENT: null },
                loader: { ...state.loader, GET_SINGLE_IMPORTED_BATCH_PAYMENT: null },
                success: { ...state.success, GET_SINGLE_IMPORTED_BATCH_PAYMENT: true },
            }
        case BatchPaymentsActionTypes.FAILURE_GET_SINGLE_IMPORTED_BATCH_PAYMENT:
            return {
                ...state,
                batchPayment: null,
                error: { ...state.error, GET_SINGLE_IMPORTED_BATCH_PAYMENT: true },
                loader: { ...state.loader, GET_SINGLE_IMPORTED_BATCH_PAYMENT: null },
                success: { ...state.success, GET_SINGLE_IMPORTED_BATCH_PAYMENT: null },
            }
        case BatchPaymentsActionTypes.FINISH_GET_SINGLE_IMPORTED_BATCH_PAYMENT:
            return {
                ...state,
                batchPayment: null,
                error: { ...state.error, GET_SINGLE_IMPORTED_BATCH_PAYMENT: null },
                loader: { ...state.loader, GET_SINGLE_IMPORTED_BATCH_PAYMENT: null },
                success: { ...state.success, GET_SINGLE_IMPORTED_BATCH_PAYMENT: null },
            }

        /*******************  Fetch Selected Batch Payments Requests ********************* */
        case BatchPaymentsActionTypes.START_GET_BATCH_PAYMENT_REQUESTS:
            return {
                ...state,
                loader: { ...state.loader, GET_BATCH_PAYMENT_REQUESTS: true },
            }
        case BatchPaymentsActionTypes.SUCCESS_GET_BATCH_PAYMENT_REQUESTS:
            return {
                ...state,
                batchPaymentRequests: action.payload,
                error: { ...state.error, GET_BATCH_PAYMENT_REQUESTS: null },
                loader: { ...state.loader, GET_BATCH_PAYMENT_REQUESTS: null },
                success: { ...state.success, GET_BATCH_PAYMENT_REQUESTS: true },
            }
        case BatchPaymentsActionTypes.FAILURE_GET_BATCH_PAYMENT_REQUESTS:
            return {
                ...state,
                batchPaymentRequests: null,
                error: { ...state.error, GET_BATCH_PAYMENT_REQUESTS: true },
                loader: { ...state.loader, GET_BATCH_PAYMENT_REQUESTS: null },
                success: { ...state.success, GET_BATCH_PAYMENT_REQUESTS: null },
            }
        case BatchPaymentsActionTypes.FINISH_GET_BATCH_PAYMENT_REQUESTS:
            return {
                ...state,
                batchPaymentRequests: null,
                error: { ...state.error, GET_BATCH_PAYMENT_REQUESTS: null },
                loader: { ...state.loader, GET_BATCH_PAYMENT_REQUESTS: null },
                success: { ...state.success, GET_BATCH_PAYMENT_REQUESTS: null },
            }

        default:
            return state
    }
}

export default batchPaymentsReducer
